import { useEffect } from "react";
import { HubConnectionState } from "@microsoft/signalr";

import { useAuthContext } from "src/auth/hooks";

import { connection } from "./connection";


export const SignalRProvider = ({ children }) => {
  const { user } = useAuthContext();

  useEffect(() => {
    if (!user) {
      if (connection.state === HubConnectionState.Connected) {
        connection.stop();
      }
      return undefined;
    }

    const start = async () => {
      try {
        await connection.start();
      } catch (err) {
        console.error("SignalR connection failed:", err);
      }
    };

    if (connection.state === HubConnectionState.Disconnected) {
      start();
    }

    return () => {
      if (connection.state === HubConnectionState.Connected) {
        connection.stop();
      }
    };
  }, [user]);

  return children;
};